<div class="w-full flex flex-col gap-4">
    <div *ngIf="taskList.length > 0;" class="relative">
        <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
            <lucide-icon [img]="icons.Search"></lucide-icon>
        </div>
        <input type="search"
            class="block w-full p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
            [(ngModel)]="searchQuery" (input)="filterAssessCases()" placeholder="Search Assessment Case..." />
    </div>
    <div class="h-full overflow-y-auto">
        <ng-container
            *ngIf="mergedTasks.length > 0; else emptyTasks">
            <table class="w-full text-left">
                <thead class="oswald-font text-gray-700 uppercase bg-main-background">
                    <tr>
                        <th scope="col" class="px-4 py-3">
                            <div class="flex items-center justify-start gap-1 cursor-pointer">
                                No.
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3">
                            <div class="flex items-center justify-start gap-1 cursor-pointer">
                                Case No.
                                <lucide-icon (click)="sortList('case_id')" [img]="icons.ArrowUpDown"
                                    size="18"></lucide-icon>
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3">
                            <div class="flex items-center justify-start gap-1 cursor-pointer">
                                Status
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3">
                            <div class="flex items-center justify-start gap-1 cursor-pointer">
                                Stage
                                <lucide-icon (click)="sortList('current_stage')" [img]="icons.ArrowUpDown"
                                    size="18"></lucide-icon>
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3">
                            <div class="flex items-center justify-start gap-1 cursor-pointer">
                                Requested At
                                <lucide-icon (click)="sortList('date_requested')" [img]="icons.ArrowUpDown"
                                    size="18"></lucide-icon>
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3">
                            <div class="flex items-center justify-start gap-1 cursor-pointer">
                                Requested By
                                <lucide-icon (click)="sortList('requested_by_name')" [img]="icons.ArrowUpDown"
                                    size="18"></lucide-icon>
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3">
                            <div class="flex items-center justify-start gap-1 cursor-pointer">
                                Action
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let task of mergedTasks | paginate: { itemsPerPage: itemsPerPage, currentPage: page }; let i = index"
                        class="bg-white border-b">
                        <th class="px-4 py-4">{{ (page - 1) * itemsPerPage + i + 1 }}</th>
                        <th class="px-4 py-4 font-medium text-gray-900 whitespace-nowrap">{{ task.case_id }}</th>
                        <td class="px-4 py-4 whitespace-pre-line">{{ task.taskType }} pending</td>
                        <td class="px-4 py-4">{{ this.stageName[task.current_stage] }}</td>
                        <td class="px-4 py-4">
                            {{ task.requested_at || task.date_requested | date: 'MM/dd/yyyy - HH:mm' }}
                        </td>
                        <td class="px-4 py-4">{{ task.requested_by_name }}</td>
                        <td class="px-4 py-4">
                            <button *ngIf="task.taskType === 'Stage Review'"
                                class="px-2 py-1.5 rounded border border-nside-gray-200 text-nside-gray-200 flex items-center justify-center hover:bg-gradient-to-b hover:from-nside-gray-100 hover:to-nside-gray-200 hover:text-white"
                                (click)="openModal('review modal', task)">
                                Stage Review
                            </button>
                            <button *ngIf="task.taskType === 'ROAR Assignment Form'"
                                class="px-2 py-1.5 rounded border border-nside-gray-200 text-nside-gray-200 flex items-center justify-center hover:bg-gradient-to-b hover:from-nside-gray-100 hover:to-nside-gray-200 hover:text-white"
                                (click)="goToPage(stageName[task.current_stage], 'form/roar-assignment-form', task.case_id, task.roar_id)">
                                ROAR Assignment Form
                            </button>
                            <button *ngIf="task.taskType === 'ROAR Activity'"
                                class="px-2 py-1.5 rounded border border-nside-gray-200 text-nside-gray-200 flex items-center justify-center hover:bg-gradient-to-b hover:from-nside-gray-100 hover:to-nside-gray-200 hover:text-white"
                                (click)="goToPage(stageName[task.current_stage], 'form/roar-activity', task.case_id, task.roar_id)">
                                ROAR Activity
                            </button>
                            <button *ngIf="task.taskType === 'ROAR Review'" 
                                class="px-2 py-1.5 rounded border border-nside-gray-200 text-nside-gray-200 flex items-center justify-center hover:bg-gradient-to-b hover:from-nside-gray-100 hover:to-nside-gray-200 hover:text-white"
                                (click)="goToPage(stageName[task.current_stage], 'form/roar-review', task.case_id, task.roar_id)">
                                ROAR Review
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </ng-container>
        <ng-template #emptyTasks>
            <div class="w-full text-nside-gray-100 italic">
                Empty Tasks
            </div>
        </ng-template>
    </div>
    <div class="flex justify-between items-center">
        <p>{{ mergedTasks.length }} in total</p>
        <pagination-controls
            *ngIf="mergedTasks.length > this.itemsPerPage"
            (pageChange)="page = $event"
            previousLabel="Prev" 
            nextLabel="Next" 
            class="mt-2"
        ></pagination-controls>
    </div>
</div>

<evaluations-review-modal *ngIf="this.showReviewModal && this.selectedTask?.current_stage===this.stageName.Evaluations"
    [task]="this.selectedTask" (onSend)="handleSave($event, 'review modal')"
    (onClose)="closeModal('review modal')"></evaluations-review-modal>

<assessments-review-modal
    *ngIf="this.showReviewModal && this.selectedTask && this.selectedTask?.current_stage===this.stageName.Assessments"
    [taskId]="this.selectedTask.case_id" (onSend)="handleSave($event, 'review modal')"
    (onClose)="closeModal('review modal')"></assessments-review-modal>

<plans-review-modal
    *ngIf="this.showReviewModal && this.selectedTask && this.selectedTask?.current_stage===this.stageName.Plans"
    [taskId]="this.selectedTask.case_id" (onSend)="handleSave($event, 'review modal')"
    (onClose)="closeModal('review modal')"></plans-review-modal>

<intervention-review-modal
    *ngIf="this.showReviewModal && this.selectedTask && this.selectedTask?.current_stage===this.stageName.Interventions"
    [taskId]="this.selectedTask.case_id" (onSend)="handleSave($event, 'review modal')"
    (onClose)="closeModal('review modal')"></intervention-review-modal>

<monitoring-review-modal
    *ngIf="this.showReviewModal && this.selectedTask && this.selectedTask?.current_stage===this.stageName.Monitoring"
    [taskId]="this.selectedTask.case_id" (onSend)="handleSave($event, 'review modal')"
    (onClose)="closeModal('review modal')"></monitoring-review-modal>

<div *ngIf="loading">
    <spinner></spinner>
</div>

<popup-message [type]="messageModal" [message]="popupMessage" (close)="resetMessageModal()"></popup-message>